import axios from "axios";
import { ENDPOINT } from "constants/environment";
import { encryptData } from "helpers";
import { decryptData } from "helpers";
import { getHeaderConfig } from "helpers";
import { consoleLog } from "helpers";

export const getWebPromptsAPI = async (payload, setIsLoading, accessJWT) => {
  try {
    setIsLoading(true);
    const config = getHeaderConfig(null, accessJWT);

    const body = {
      skip: payload.pageIndex + 1,
      limit: payload.limit,
    };

    const response = await axios.post(
      `${ENDPOINT}/app/v1/WebsitePrompts/search`,
      encryptData(body),
      config
    );

    const decrypted = decryptData(response?.data);
    consoleLog(["Decrypted WebPromptsAPI response:", decrypted]);

    const parsedResponseData = JSON.parse(decrypted);
    setIsLoading(false);

    if (parsedResponseData?.statusCode === 200) {
      return {
        data: parsedResponseData?.data.data,
        totalPages: parsedResponseData?.data.pagination?.totalPages,
      };
    }

    throw new Error("Failed to fetch Web Prompts");
  } catch (error) {
    setIsLoading(false);
    console.error("Error fetching data:", error);
    return null;
  }
};

export const getFilterWebPrompts = async (payload, setIsLoading, accessJWT) => {
  try {
    setIsLoading(true);
    const config = getHeaderConfig(null, accessJWT);
    consoleLog([payload, "payload"]);

    const body = {
      searchQuery: payload.searchQuery,
      skip: payload.pageIndex + 1,
      limit: payload.limit,
    };
    const response = await axios.post(
      `${ENDPOINT}/app/v1/WebsitePrompts/search`,
      encryptData(body),
      config
    );

    const decrypted = decryptData(response?.data);
    consoleLog(["Decrypted FilterWebPrompts response:", decrypted]);

    const parsedResponseData = JSON.parse(decrypted);
    setIsLoading(false);

    if (parsedResponseData?.statusCode === 200) {
      return {
        data: parsedResponseData?.data.data,
        totalPages: parsedResponseData.data.pagination?.totalPages,
      };
    }

    throw new Error("Error fetching data");
  } catch (error) {
    setIsLoading(false);
    console.error("Error fetching data:", error);
    return { data: [], totalPages: 0 };
  }
};

export const createOrUpdateWebPromptsAPI = async (
  args,
  isLoading,
  accessJWT
) => {
  const API_URL = `${ENDPOINT}/app/v1/WebsitePrompts`;
  try {
    if (isLoading) isLoading(true);
    const config = getHeaderConfig(null, accessJWT);
    const response = args?.id
      ? await axios.put(
          API_URL,
          encryptData({ ...args, section: args.section }),
          config
        )
      : await axios.post(
          API_URL,
          encryptData({ ...args, section: args.section }),
          config
        );
    const parsedResponseData = JSON.parse(decryptData(response?.data));
    if (parsedResponseData && parsedResponseData?.statusCode === 200) {
      if (isLoading) isLoading(false);
      return parsedResponseData?.data;
    }
    if (isLoading) isLoading(false);
    isLoading(false);
    throw Error;
  } catch (error) {
    isLoading(false);
    console.error("Error creating/updating  Web Prompts:", error);
    return null;
  }
};

export const deleteWebPromptsAPI = async (args, isLoading, accessJWT) => {
  const API_URL = `${ENDPOINT}/app/v1/WebsitePrompts/${args.id}`;
  try {
    if (isLoading) isLoading(true);
    const config = getHeaderConfig(null, accessJWT);
    const response = await axios.delete(API_URL, config);
    const parsedResponseData = JSON.parse(decryptData(response?.data));
    if (parsedResponseData) {
      if (isLoading) isLoading(false);
      return parsedResponseData;
    }
    if (isLoading) isLoading(false);
    isLoading(false);
    throw Error;
  } catch (error) {
    isLoading(false);
    console.error("Error deleting  Web Prompts:", error);
    return null;
  }
};
